import useDocumentTitle from "../../util/useDocumentTitle";
import { Box, Button, CircularProgress } from "@mui/material";
import { useState } from "react";
import { useGetVesselStatsQuery } from "../../redux/api/vessel";
import AdminStatsForm from "./AdminStatsForm";
import { toast } from "react-toastify";

const AdminStatsPage = () => {
  useDocumentTitle("Vessel Safety Statistics");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [changedRowsWithError, setChangedRowsWithError] = useState<number[]>(
    []
  );
  const {
    data: vesselStats,
    isLoading: isVesselStatsLoading,
    isFetching: isVesselStatsFetching,
  } = useGetVesselStatsQuery({});

  const handleCallback = (saveResult: {
    data: {
      successCount: number;
      failed: boolean;
    };
    hasData: boolean;
    errors: number[];
    hasError: boolean;
    noChange: boolean;
  }) => {
    if (saveResult.hasData) {
      if (saveResult.data.successCount > 0) {
        toast.success(
          <p>
            Changes for {saveResult.data.successCount} record(s) saved
            successfully.
          </p>,
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
      if (saveResult.data.failed) {
        toast.error(<p>Changes could not be saved.</p>, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
    if (saveResult.hasError) {
      setChangedRowsWithError(saveResult.errors);
      toast.error(<p>Required fields are missing or incorrectly filled.</p>, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (saveResult.noChange) {
      setChangedRowsWithError([]);
      toast.info(<p>No changes to save.</p>, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    setFormSubmitted(false);
  };

  if (isVesselStatsLoading || isVesselStatsFetching) {
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {!isVesselStatsLoading && !isVesselStatsFetching && (
        <>
          <div className="roster-page-header mb-0">
            <div className="header-group">
              <h1>Vessel Safety Statistics</h1>
            </div>
            <div className="header-button">
              {
                <Button
                  form="vesselStatsForm"
                  variant="contained"
                  className="blue-button wd-auto ht-4px"
                  type="submit"
                  disabled={formSubmitted}
                >
                  {" "}
                  {formSubmitted === true ? (
                    <CircularProgress className="flex align-items-center color-white wd-2px" />
                  ) : (
                    "Save Changes"
                  )}
                </Button>
              }
            </div>
          </div>
          <AdminStatsForm
            parentCallback={handleCallback}
            vesselStats={vesselStats!}
            changedRowsWithError={changedRowsWithError}
            formSubmitted={formSubmitted}
            setFormSubmitted={setFormSubmitted}
          />
        </>
      )}
    </>
  );
};

export default AdminStatsPage;
